import { render, staticRenderFns } from "./withdrawInfo.vue?vue&type=template&id=037ba600"
import script from "./withdrawInfo.vue?vue&type=script&lang=js"
export * from "./withdrawInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports